<script setup lang="ts">
    const props = defineProps<{
        labels: string[];
        counts: Record<string, number>;
        logos: Array<string | null>;
        choiceIds: string[];
        disabled: boolean;
    }>();

    const emit = defineEmits<{(event: 'choose', choice: {label: string; choiceId: string | null}): void}>();

    // The count is shown but never part of the label: clicking resends the label verbatim as the
    // next message, and the backend matches it whole against the real facet values to apply the
    // filter automatically.
    function caption(label: string): string {
        return Object.prototype.hasOwnProperty.call(props.counts ?? {}, label) ? `${label} (${props.counts[label]})` : label;
    }
</script>

<template>
    <div>
        <p class="text-muted mb-10">Kies een optie:</p>
        <div class="chat-pills">
            <button
                v-for="(label, index) in labels"
                :key="index"
                type="button"
                class="btn btn-default"
                :disabled="disabled"
                @click="emit('choose', {label, choiceId: choiceIds?.[index] ?? null})">
                <img
                    v-if="logos?.[index]"
                    class="choices__logo"
                    :src="logos[index]!"
                    alt=""
                    loading="lazy"
                    decoding="async" />
                <span>{{ caption(label) }}</span>
            </button>
        </div>
    </div>
</template>

<style scoped>
    .choices__logo {
        width: 2rem;
        height: 1.25rem;
        margin-right: 6px;
        object-fit: contain;
    }
</style>
